"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VECTOR_ICONS = exports.VECTOR_ICONS = function VECTOR_ICONS(id) {
  return "/vector/" + id + ".svg";
};